import React from 'react';
import SocialIcons from "../Social/SocialIcons";
import {Link} from "react-router-dom";
import './Footer.style.scss';
import {FormattedMessage} from "react-intl";
import GlobalConst from "../../constants/GlobalConst";

const Footer = () => {
    return <div className="Footer">
        <div className="container">
            <div className="logoSocialPartners">
                <div className={"logoAndSocial"}>
                    <div className="tradefanLogo">
                        <Link
                            to="/lobby"
                            className={"tf-logo www "}
                        />
                    </div>
                    <SocialIcons/>
                </div>
                <div className="partners">
                    <Link to="https://www.sportradar.com"
                       target="_blank"
                       className="sportradar-logo" rel="noreferrer"></Link>
                    <Link to="https://www.tsevo.com/Products"
                       target="_blank"
                       className="tsevo-logo" rel="noreferrer"></Link>
                    {/*<a href="https://www.paypal.com" target="_blank" className="paypal-logo"></a>*/}
                    {GlobalConst.FEATURES.DOTMX ? <Link
                        to="https://www.nuvei.com"
                        target="_blank"
                        className="nuvei-logo" rel="noreferrer"
                    ></Link> : <Link
                        to="https://www.paysafe.com"
                        target="_blank"
                        className="paysafe-logo" rel="noreferrer"
                    ></Link>}
                    <Link
                        to="https://discord.gg/CJtjGz9tF4"
                        target="_blank"
                        className="discord-logo" rel="noreferrer"
                    ></Link>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    {/*<ResponsibleGaming t={t} openContactUsPopUp={openContactUsPopUp}/>*/}
                </div>
            </div>
            <div>
                <div className="col-xs-12">
                    <div className="copyright-col">
                        <div className="sepLine">
                            2024©TradeFan Inc. <FormattedMessage id="footer.rightsReserved"/>
                        </div>
                        <Link to="/TermsOfUse">
                            <FormattedMessage id="footer.termsOfUse"/>
                        </Link>{" "}
                        |{" "}
                        <Link to="/PrivacyPolicy">
                            <FormattedMessage id="footer.privacyPolicy"/>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Footer;